import { HEADERS } from "../../../constants/headers/headers.constants";
import type { RequestProps } from "../../../request/request";
import { request } from "../../../request/request";

export type RequestSessionLogoutProps = Pick<RequestProps, "headers">;

export const requestSessionLogout = ({
  headers = {},
}: RequestSessionLogoutProps) =>
  request({
    headers: { ...HEADERS, ...headers },
    method: "POST",
    urlBackendPath: "/me/logout",
  });
